import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Row, Col } from 'react-bootstrap'
import { Card, CardTitle, CardActions, CardText } from 'material-ui/Card'
import { jsonApiHttpClient } from './../services/fetch'
import constants from '../utils/constants'
import FlatButton from 'material-ui/FlatButton'
import DatePicker from 'material-ui/DatePicker'
import TransactionHistory from '../components/transactionHistory'
import Snackbar from 'material-ui/Snackbar'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'

import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export'
import { process } from '@progress/kendo-data-query'

const styles = {
  flex: {
    display: 'flex',
    marginTop: '2em'
  },
  left: {
    flex: 1
  },
  right: {
    flex: 2
  },
  bills: {
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    cursor: 'pointer'
  },
  total: {
    fontSize: 12,
    color: '#bababa',
    cursor: 'pointer'
  },
  button: {
    textTransform: 'uppercase',
    fontSize: 14,
    color: '#1E1E1E',
    padding: 5,
    cursor: 'pointer',
    textAlign: 'center'
  },
  datePicker: {
    width: 150
  }
}

const fuelType = {
  gas: 'Gasolina',
  premiumGas: 'Gasolina Aditivada',
  ethanol: 'Etanol',
  diesel: 'Diesel'
}

const dateTimeFormat = global.Intl.DateTimeFormat

class TransactionReport extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      startDate: new Date(new Date().getFullYear(), new Date().getMonth()),
      endDate: new Date(),
      loading: true,
      transactions: [],
      organizations: [],
      gasStations: [],
      organization: '',
      gasStation: '',
      filterRequired: false
    }

    this._exporter = null
  }

  componentDidMount () {
    this.getOrganizations()
    this.getGasStations()
  }

  getOrganizations () {
    jsonApiHttpClient(`${constants.apiUrl}/organization?isDeleted=false&status=active`, {
      user: {
        //eslint-disable-next-line
        token: localStorage.getItem('token'),
        authenticated: true
      }
    }).then(response => {
      if (response.json.docs.length) {
        this.setState({ organizations: response.json.docs })
      }
    }).catch(error => {
      if (error.status === 401) {
        window.location = '#/login'
      }
    })
  }

  getGasStations () {
    jsonApiHttpClient(`${constants.apiUrl}/gasStation?isDeleted=false`, {
      user: {
        //eslint-disable-next-line
        token: localStorage.getItem('token'),
        authenticated: true
      }
    }).then(response => {
      if (response.json.docs.length) {
        this.setState({ gasStations: response.json.docs })
      }
    }).catch(error => {
      if (error.status === 401) {
        window.location = '#/login'
      }
    })
  }

  export = () => {
    const { transactions } = this.state

    if (!transactions.length) {
      this.setState({ filterRequired: true })
      return;
    }
    
    this._exporter.save()
  }

  mapTransactions = (transactions) => _.map(transactions, transaction => ({
    _id: transaction._id,
    createdAt: transaction.createdAt,
    formatedCreatedAt: moment(transaction.createdAt).format('DD/MM/YYYY HH:mm'),
    value: transaction.value,
    fuelType: _.get(fuelType, transaction.fuelType, transaction.fuelType),
    fuelCost: transaction.fuelCost,
    licensePlate: transaction._vehicle ? transaction._vehicle.licensePlate : '-',
    odometer: transaction.odometer,
    _user: { firstName: transaction._user.name },
    _gasStation: { name: transaction._gasStation.name },
    _receipt: transaction._receipt ? { number: transaction._receipt.number } : ''
  }))

  getTransactions () {
    const { startDate, endDate, organization, gasStation } = this.state

    // if (!organization) {
    //   this.setState({ filterRequired: true })
    //   return
    // }

    if (startDate && endDate) {
      const newStartDate = moment(startDate).format('YYYY-MM-DD');
      const newEndDate = moment(endDate).format('YYYY-MM-DD');

      const startDateParam = `startDate=${newStartDate}`
      const endDateParam = `endDate=${newEndDate}`
      const organizationParam = `organization=${organization}`
      const gasStationParam = `gasStation=${gasStation}`

      jsonApiHttpClient(`${constants.apiUrl}/admin/transaction/report?${startDateParam}&${endDateParam}&${organization ? '&' + organizationParam : ''}${gasStation ? '&' + gasStationParam : ''}`, {
        user: {
          //eslint-disable-next-line
          token: localStorage.getItem('token'),
          authenticated: true
        }
      }).then(response => {
        const transactions = this.mapTransactions(response.json.docs)

        this.setState({
          transactions,
          formattedTransactions: process(transactions, {}).data,
          loading: false,
          filterRequired: false
        })
      }).catch(error => {
        if (error.status === 401) {
          window.location = '#/login'
        }
      })
    }
  }

  filter () {
    this.getTransactions()
  }

  handleChangeOrganization = (event, index, organization) => this.setState({ organization, filterRequired: false })

  handleChangeGasStation = (event, index, gasStation) => this.setState({ gasStation })

  render () {
    const { transactions, formattedTransactions, organizations, gasStations } = this.state
    const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth())
    return (
      <div>
        <Row>
          <Col lg={12}>
            <Card>
              <CardTitle title='Abastecimentos' />
              <CardText style={{ display: 'flex', flexDirection: 'row', paddingLeft: 16, paddingRight: 16, paddingTop: 0, paddingBottom: 0 }}>
                <DatePicker
                  autoOk
                  DateTimeFormat={dateTimeFormat}
                  floatingLabelText="Data inicial" 
                  locale="pt-BR"
                  style={{ marginRight: 10 }}
                  textFieldStyle={styles.datePicker}
                  defaultDate={firstDayOfMonth}
                  formatDate={(date) => moment(date).format('DD/MM/YYYY')}
                  onChange={(event, date) =>
                    this.setState({ startDate: moment(date).format('YYYY-MM-DD'), filterRequired: false })
                  }
                />
                <DatePicker
                  autoOk
                  DateTimeFormat={dateTimeFormat}
                  floatingLabelText="Data final"
                  locale="pt-BR"
                  style={{ marginRight: 10 }}
                  textFieldStyle={styles.datePicker}
                  defaultDate={new Date()}
                  formatDate={(date) => moment(date).format('DD/MM/YYYY')}
                  onChange={(event, date) => {
                    this.setState({ endDate: moment(date).format('YYYY-MM-DD'), filterRequired: false })
                    this.filter()
                  }}
                />
              </CardText>
              <CardText style={{ display: 'flex', flexDirection: 'row', paddingLeft: 16, paddingRight: 16, paddingTop: 0, paddingBottom: 0 }}>
              <SelectField
                  floatingLabelText="Empresa"
                  style={{ marginRight: 10 }}
                  onChange={this.handleChangeOrganization}
                  value={this.state.organization}
                  fullWidth
                >
                  {
                    organizations.length &&
                    _.map(organizations, (organization, index) => 
                      <MenuItem key={index} value={organization._id} primaryText={organization.name} />
                    )
                  }
                </SelectField>
                <SelectField
                  floatingLabelText="Posto"
                  style={{ marginRight: 10 }}
                  onChange={this.handleChangeGasStation}
                  value={this.state.gasStation}
                  fullWidth
                >
                  {
                    gasStations.length &&
                    _.map(gasStations, (gasStation, index) => 
                      <MenuItem key={index} value={gasStation._id} primaryText={gasStation.name} />
                    )
                  }
                </SelectField>
              </CardText>
              <CardActions>
                <FlatButton label='Filtrar' onClick={() => this.filter()} />
                <FlatButton label='Exportar' onClick={this.export} />
                <ExcelExport
                    data={formattedTransactions}
                    fileName="litroz.xlsx"
                    ref={exporter => this._exporter = exporter}
                >
                  <ExcelExportColumn field="_id" title="ID" locked={true} width={200} />
                  <ExcelExportColumn
                    field="formatedCreatedAt"
                    title="Data"
                    width={150}
                  />
                  <ExcelExportColumn field="_user.firstName" title="Usuário" width={250} />
                  <ExcelExportColumn field="licensePlate" title="Placa" />
                  <ExcelExportColumn field="odometer" title="Odometro" />
                  <ExcelExportColumn field="_gasStation.name" title="Posto" width={250} />
                  <ExcelExportColumn field="fuelType" title="Combustível" width={150} />
                  <ExcelExportColumn
                    field="fuelCost"
                    title="Preço"
                    cellOptions={{ format: '#,##0.000' }}
                    width={150}
                    footerCellOptions={{ wrap: true, textAlign: 'center' }}
                  />
                  <ExcelExportColumn
                    field="value"
                    title="Valor"
                    cellOptions={{ format: '#,##0.00' }}
                    width={150}
                    footerCellOptions={{ wrap: true, textAlign: 'center' }}
                  />
                  <ExcelExportColumn field="_receipt.number" title="Núm. Cupom" />
                </ExcelExport>
              </CardActions>
            </Card>
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col lg={12}>
            <Card>
              <TransactionHistory data={transactions} hideEfficiency={true} />
            </Card>
          </Col>
        </Row>
        <Snackbar
          open={this.state.filterRequired}
          message='Selecione um período de datas e uma empresa, depois clique em filtrar antes de exportar os dados'
          autoHideDuration={3000}
        />
      </div>
    )
  }
}

export default TransactionReport



// WEBPACK FOOTER //
// ./src/components/transactionReport.js